import GOIRoot from "./component/GOIRoot";
import { ObjectInputProvider } from "./contexts/objectInputContext";
// Importing global styles
import "./assets/styles/global.css";

// its the HOC for the generated object input and wraps it in the context provider
// it takes inputId, onSave and onError as props, and passes all to the context provider
const GeneratedObject = ({ inputId, onSave, onError }) => {
  return (
    // The ObjectInputProvider is used to provide context to its children
    <ObjectInputProvider
      inputId={inputId}
      onErrorCb={onError}
      onSaveCb={onSave}
      key={inputId}
    >
      <GOIRoot />
    </ObjectInputProvider>
  );
};

export default GeneratedObject;
